import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * @description convert a date string to iso string while substracting a timezone offset and adding the window timezone offset
 * @param date a date string of whatever format
 * @param timezone
 * @returns iso string
 */
export function timezoneDateToFieldValue(
  date?: string,
  timezone?: string | null
) {
  return dayjs(date || undefined)
    .add(
      dayjs()
        .tz(timezone ?? undefined)
        .utcOffset(),
      'minute'
    )
    .subtract(dayjs().utcOffset(), 'minute')
    .toISOString();
}
/**
 *
 * @description convert date string without timezone info to iso string using a provided timezone
 * @param date a date string like 2021-09-01 00:00:00
 * @param timezone
 * @returns iso string
 */
export function userInputToTimezoneDate(
  date: string,
  timezone?: string | null
) {
  const offset = dayjs()
    .tz(timezone ?? undefined)
    .utcOffset();
  return dayjs(date || undefined, {
    utc: true,
  })
    .subtract(offset, 'minute')
    .toISOString();
}
